export const localization = {
  en: {
    signIn: 'Sign In',
    welcome: 'Welcome',
    subTitle: "Your Destination for Children's Health",
    getAccess: 'Get access to medical records and more with a MyCHOC account.',
    learnMore: 'Learn more.',
    learnMoreContent: 'To access medical records and personal health information, you must sign in with your MyCHOC account. If you do not have a MyCHOC account, you may create a new account. Please note, it could take up to three business days to set up a new account.',
    createAccount: 'create account'
  },
  es: {
    signIn: 'Iniciar sesión',
    welcome: 'Bienvenido',
    subTitle: 'Su destino para la salud de los niños',
    getAccess: 'Obtén acceso a registros médicos y más con una cuenta de MyCHOC.',
    learnMore: 'Obtenga más información.',
    learnMoreContent: 'Para acceder a los registros médicos y la información personal de salud, debes iniciar sesión con tu cuenta de MyCHOC. Si no tienes una cuenta de MyCHOC, puedes crear una nueva cuenta. Ten en cuenta que puede tomar hasta tres días hábiles configurar una nueva cuenta.',
    createAccount: 'CREAR UNA CUENTA'
  },
  keyMapping: {
    signIn: 'UFD_Auth_Sign_In_Button',
    welcome: 'UFD_Auth_Welcome_Text',
    subTitle: 'UFD_Auth_Subtitle',
    getAccess: 'UFD_Auth_Get_Access_Label',
    learnMore: 'UFD_Auth_Learn_More_Text',
    learnMoreContent: 'UFD_Auth_Learn_More_Content',
    createAccount: 'UFD_Create_Account_Text'
  }
}
